const checkDeleteCompanyCallFormService = {
  confirm: '¿Realmente desea eliminar este servicio? Se eliminarán todas las acciones relacionadas a este servicio',
  title: 'ELIMINAR SERVICIO'
};

export default checkDeleteCompanyCallFormService;
